import React, { useState } from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import { motion } from 'framer-motion';

const techLogos = [
  { id: 'togaf', src: '/togaf.png' },
  { id: 'aws-ml', src: '/AWSMac.webp' },
  { id: 'aws-sec', src: '/AWSSec.png' },
  { id: 'aws-sol', src: '/AWSSol.webp' },
  { id: 'azure-ai', src: '/AzureAI.png' },
  { id: 'gcp', src: '/GCP.png' },
  { id: 'oracle-genai', src: '/OraGenAI.png' },
  { id: 'finops', src: '/FinOps.png' },
  { id: 'snow', src: '/snow.png' },
];

const FloatingTechLogos: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isDark = theme.palette.mode === 'dark';
  const [isHovered, setIsHovered] = useState(false);

  if (isMobile) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'absolute',
        top: '120px',
        right: { lg: '120px', xl: '140px' },
        zIndex: 10,
        pointerEvents: 'auto',
        height: '500px', // Container to hold the fan deck
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {techLogos.map((logo, index) => (
        <motion.div
          key={logo.id}
          initial={{ opacity: 0, y: 20, x: 20, scale: 0.8 }}
          animate={{
            opacity: isHovered ? 1 : index === 0 ? 1 : 0.4,
            y: isHovered ? index * 65 : index * 8,
            x: isHovered ? 0 : index * 3,
            scale: isHovered ? 1 : 1 - index * 0.05,
            zIndex: techLogos.length - index,
          }}
          whileHover={{ 
            scale: 2, 
            x: -35, 
            zIndex: techLogos.length + 1 
          }}
          transition={{
            type: 'spring',
            stiffness: 180,
            damping: 25,
          }}
          style={{
            position: 'absolute',
            cursor: 'pointer',
            filter: isDark 
              ? 'drop-shadow(0 5px 15px rgba(0,0,0,0.4))'
              : 'drop-shadow(0 5px 15px rgba(0,0,0,0.15))',
          }}
        >
          <Box
            component="img"
            src={logo.src}
            alt=""
            sx={{
              height: 60,
              width: 'auto',
              borderRadius: '8px',
            }}
          />
        </motion.div>
      ))}
    </Box>
  );
};

export default FloatingTechLogos; 